import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import { push } from 'react-router-redux';

import { logOut } from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'
import UserDropdown from '../UserDropdown/UserDropdown.js'

import './Header.css';

class Header extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      top: true,
      mobileShow: false,
      search: undefined
    }
    this.handleScroll = this.handleScroll.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
  }


  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  submitSearch(e){
    const { dispatch } = this.props;

    dispatch(push('/search/' + this.state.search));
    if(e) e.preventDefault();
  }

  handleScroll(event) {

    if(window.scrollY > 500){
      this.setState({
        top: false
      });
    } else if (window.scrollY > 50 && window.location.pathname != '/'){
      this.setState({
        top: false
      });
    } else {
      this.setState({
        top: true
      });
    }
  }

  render(){
    const { dispatch, user, team, patternManager } = this.props; 
    const state = this.state;

    return <div className={"header " + (this.props.transparent ? "header-no-bg" : "")}>
      <div className={"header-mobile " + (this.state.mobileShow ? "header-mobile-show" : "header-mobile-hide") }>
        <div className="flex-split header-mobile-top">
          <Link to="/" className="list-item">
            <nobr>
              <span className="brand-font">
                <span className="brand-space-fix">P</span>attycake
              </span>
            </nobr>
          </Link>
          <span 
            className="list-item header-mobile-bars-btn"
            onClick={(e)=> { this.setState({mobileShow: false})}}
            >
            <i className="fal fa-bars fa-lg"/>
          </span>
        </div>
        {/*<Link to="/feature-table" className="header-mobile-link" onClick={(e)=> { this.setState({mobileShow: false})}}>Features</Link>*/}
        <Link to="/#pricing" className="header-mobile-link" onClick={(e)=> { this.setState({mobileShow: false})}}>Pricing</Link>
        
        <Link to="/docs" className="header-mobile-link" onClick={(e)=> { this.setState({mobileShow: false})}}>Docs</Link>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="flex-split">
              <div className="list-left">
                <Link to="/" className="list-item">
                  <nobr>
                    <span className="brand-font">
                      <span className="brand-space-fix">P</span>attycake
                    </span>
                  </nobr>
                </Link>
                <form name="HeaderForm" className="list-item header-form list-left" onSubmit={this.submitSearch}>
                  <i className="fal fa-search fa-lg translucent"/>
                  <span className="list-item" style={{marginRight: 10}}>
                    <CustomField
                      type="text"
                      name="search"
                      inline={true}
                      formName={"HeaderForm"}
                      placeholder="search for a hatch pattern..."
                      size="jumbo"
                      onChange={(e)=> { this.setState({search: e})}}
                      autoCompleteList={patternManager.officialTags}
                      />
                  </span>
                  <span className={"search-btn" + (this.state.search ? " search-btn-show" : "") }>
                    <Button
                      display="Search"
                      submit={true}
                      onClick={this.submitSearch}
                      />
                  </span>
                </form>
              </div>
              <div className="list-right">
                <span 
                  style={{marginRight: 15}}
                  className="list-item d-xl-none d-lg-none d-md-none d-sm-block"
                  onClick={(e)=> { this.setState({mobileShow: true})}}
                  >
                  <i className="fal fa-bars fa-lg"/>
                </span>

                <Link to="/at-work" className={"list-item text-400 underlined d-none d-md-block " + (window.location.pathname === '/at-work' ? "header-link-current" : "")}>Pattycake at Work</Link>
                <Link to="/pricing" className={"list-item text-400 underlined d-none d-md-block " + (window.location.pathname === '/pricing' ? "header-link-current" : "")}>Pricing</Link>
                <Link to="/docs" className={"list-item text-400 underlined d-none d-md-block " + (window.location.pathname === '/docs' ? "header-link-current" : "")}>Docs</Link>
                
                { !user.isLoggedIn && <Link to="/login" className="list-item text-400 underlined d-none d-md-block ">Log In</Link> }
                { !user.isLoggedIn && <Link to="/sign-up" className={"list-item button-link d-none d-md-block"}><Button display="Sign Up for Free" color="grey" size="medium"/></Link> }
                
                { user.isLoggedIn && <Link to="/new/drawing" className="list-item button-link d-none d-md-block ">
                  <Button display={<span>Launch Pattycake{user.roles.pro && " Pro"} &nbsp;<i className="fad fa-angle-double-right"/></span>} color="primary" size="medium"/>
                </Link> }
               
              </div>      

              <div className={"header-scrolling " + (this.state.top ? "" : " header-scrolling-show")}>
                <div className="flex-split">
                  <div className="list-left">
                    
                  </div>
                  <div className="list-right">
                    { 
                      !user.isLoggedIn && <Link to="/new/drawing" className="list-item button-link d-none d-md-block">
                        <Button display={<span>Try Pattycake for Free &nbsp;<i className="fad fa-angle-double-right"/></span>} color="primary" size="medium"/>
                      </Link> 
                    }
                    { user.isLoggedIn && <Link to="/new/drawing" className="list-item button-link d-none d-md-block">
                      <Button display={<span>Launch Pattycake &nbsp;<i className="fad fa-angle-double-right"/></span>} color="primary" size="medium"/>
                    </Link> }

                  </div>         
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}


Header = reduxForm({
  form: 'HeaderForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(Header)

Header = connect((state, ownProps) => {
  const { user, team, patternManager } = state;

  var initialValues = {
    search: ""
  };
  
  return {
    user,
    team,
    patternManager,
    initialValues
  }
})(Header);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js